angular.module('unergie.main')
.controller('claimDraftModalCtrl', ($scope, $uibModalInstance, DraftsBasic, AlertManager, ErrorCatcher, id_draft_basic) => {
    $scope.claiming = false

    $scope.claim = () => {
        $scope.claiming = true
        return DraftsBasic.claimDraft({ id_draft_basic }, {}).$promise
        .then((result) => {
            AlertManager.success(result.message)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.claiming = false
            $uibModalInstance.close()
        })
    }

    $scope.close = $uibModalInstance.dismiss
})
